import {post} from "./request";
export const pubApi = {};

pubApi.getAll = async ({page, size, ...props}) => {
  try {
    const {data} = await post(`/pub/all`, {...props}, {page, size});
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};
